import { push } from "connected-react-router";
import { Action, ActionFunction1 } from "redux-actions";
import { call, put, select } from "redux-saga/effects";

import { Creators as AllCreators } from "../../actions";
import { SagaFunction } from "../../actions/types";
import { AxiosInterceptedResult } from "../../api/interceptors";
import { ResolvableType } from "../../api/ResolveApi/resolve-api.types";
import { dependencies } from "../../dependencies";
import { ICreationResponse, IFullClass } from "../../parsers/resolve";
import { SagaAction } from "../../sagas/types";

import * as selectors from "../../selectors/selectors";

const Creators = (AllCreators as any).App.SelectOrganization;
const { api } = dependencies;

interface IAddNewClassFurtherActions {
  onSuccess: ActionFunction1<void, Action<void>>;
  onFailure: ActionFunction1<{ message: string }, Action<{ message: string }>>;
}

type OrgId = string;

export const mkDefaultClass = (admins: string[], orgOwnerId: OrgId, custom?: Partial<IFullClass>): IFullClass => ({
  admins,
  deleted: false,
  description: "",
  displayName: "New Class",
  goals: {
    elems: [],
    nextId: 0,
  },
  members: [],
  owner: orgOwnerId,
  ...(custom || {}),
});

export const addNewClass: (fa: IAddNewClassFurtherActions) => SagaFunction = fa =>
  function* _addNewClass(_): SagaAction {
    const accountId: string = yield select(selectors.accountId);
    const currentOrgId: string = yield select(selectors.organizationId);
    const defaultFullClass = mkDefaultClass([`${ResolvableType.Account}.${accountId}`], currentOrgId);
    const response: AxiosInterceptedResult<ICreationResponse<IFullClass>> = yield call(
      api.classes.create,
      defaultFullClass,
      accountId
    );

    const [err, resp] = response;

    if (err || resp === null) {
      return yield put(fa.onFailure({ message: "Failed to create class" }));
    }

    yield put(push(`/class-management/${resp.data.value}`));
    yield put(fa.onSuccess());
    yield put(Creators.loadClassAmount());
  };
